export class DataStudioConfig {
    links: {
        historicalAnalysis: string;
        laeCalculator: string;
    }
}
